import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import Tables from "../../Components/Notifications/Tables";

const Notifications = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const { id } = useParams();
  const [notificationType, setNotificationType] = useState("");
  const [isEnabled, setIsEnabled] = useState("");
  const [isSelfBranding, setIsSelfBranding] = useState("");
  const [editNotification, setEditNotification] = useState(false);
  const [apiData, setApiData] = useState();
  const { t } = useTranslation();
  const location = useLocation();

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("propId", id);
    return await axios.post(`${Config.apiUrl}/getsettings`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getNotificationsSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) error = true;
    setApiData(res.data);
  };
  const getNotificationsError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getNotificationsMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getNotificationsSuccess,
    onError: getNotificationsError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getNotificationsMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  // ------- update Single Entry -------
  const updateNotification = async (values) => {
    const body = new FormData();
    body.append("propId", id);
    body.append("clientId",apiData?.data?.clientId);
    body.append("whatsApp", values.whatsApp);
    body.append("sms", values.sms);
    body.append("rentReminder", values.rentReminder);
    body.append("onboardWelcome", values.onboardWelcome);
    body.append("partialPayment", values.partialPayment);
    body.append("onlinePayment", values.onlinePayment);
    body.append("isWhatsSelfBranding", values.isWhatsSelfBranding);
    body.append("isSMSSelfBranding ", values.isSMSSelfBranding);
    return await axios.post(`${Config.apiUrl}/editsettingpref`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUpdateNotificationSucess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      // getNotificationsMutate();
      setApiData(data.data);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditNotification(false);
  };

  const onEditNotificationError = (data) => {
    setSelectedData("");
    setEditNotification(false);
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEntryLoading, mutate: editNotificationMutate } =
    useMutation(updateNotification, {
      onSuccess: onUpdateNotificationSucess,
      onError: onEditNotificationError,
    });

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Notifications")}
                <span>/{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>

          {!error && !isLoading && data && (
            <TableWrapper>
              <Tables
                ApiData={apiData?.data || []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditNotification={setEditNotification}
                editNotificationMutate={editNotificationMutate}
                editEntryLoading={editEntryLoading}
                userType={user.userType}
                updatenotification={updateNotification}
              />
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default Notifications;
